import { isInsideHtmlEditor } from "../core/HtmlEditor";
import ScriptInstaller from "../core/ScriptInstaller";

export let timelinePolyfillInstalled: Promise<void>;

if (!isInsideHtmlEditor(document.body)) {
    if (typeof (window as any).ScrollTimeline === "undefined") {
        timelinePolyfillInstalled = ScriptInstaller.install("https://cdn.jsdelivr.net/npm/@web-atoms/scroll-timeline@latest/dist/main.js");
    }
}